// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3c48-","header":"MergedInvoice_header__2dCAC"};